import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from '@/components/Breadcrumbs';
import { Card } from '@/components/ui/Card';
import { apiClient } from '@/lib/apiClient';

interface DialerAnalytics {
  totalCalls: number;
  byOutcome: Record<string, number>;
}

export function DialerAnalyticsPage() {
  const { t } = useTranslation();
  const [data, setData] = useState<DialerAnalytics | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient
      .get('/api/v1/dialer/analytics')
      .then((r) => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6 p-6">
      <Breadcrumbs
        crumbs={[
          { label: t('dialer.title'), to: '/dialer' },
          { label: t('dialer.analytics_title') },
        ]}
      />
      <h1 className="text-2xl font-bold">{t('dialer.analytics_title')}</h1>
      <Card className="space-y-4 p-6">
        {loading ? (
          <p className="text-sm text-muted-foreground">{t('common.loading')}</p>
        ) : !data ? (
          <p className="text-sm text-muted-foreground">{t('dialer.analytics_empty')}</p>
        ) : (
          <>
            <div className="text-3xl font-bold">{data.totalCalls}</div>
            <p className="text-sm text-muted-foreground">{t('dialer.total_calls')}</p>
            <h3 className="mt-4 font-semibold">{t('dialer.by_outcome')}</h3>
            <div className="space-y-2">
              {Object.entries(data.byOutcome).map(([outcome, count]) => (
                <div key={outcome} className="flex items-center justify-between">
                  <span className="text-sm">{t(`dialer.disposition_${outcome}`)}</span>
                  <span className="font-medium">{count}</span>
                </div>
              ))}
            </div>
          </>
        )}
      </Card>
    </div>
  );
}
